import { ChatAdapterBuilder } from './builder';
import { LangGraphAdapterBuilderImpl } from './builderImpl';

export const createChatAdapter = <AiMsg = string>(): ChatAdapterBuilder<AiMsg> => {
  return new LangGraphAdapterBuilderImpl();
};
